import { useMutation } from '../useMutation'
import { resetPasswordQuery } from './graphql'

export const useResetPassword = () => {
  const [resetPassword, , { loading, error }] = useMutation({ query: resetPasswordQuery })

  const executeIt = ({ _id }) => {
    return resetPassword({ input: { userId: _id } })
  }

  return { executeIt, loading, error }
}
